<template>
  <div class="col-12 d-flex flex-column align-items-center p-0 m-0">
    <div
      class="col-12 d-flex flex-column align-items-center p-0 m-0"
      v-if="!eliminarRegistro"
    >
      <ScenarioDatatable
        class="col-12 d-flex flex-column align-items-center mb-4 mt-4"
        :opcionVer="false"
        :scenarios="{ data: [scenario] }"
      />

      <div class="mt-2 d-flex">
        <PreviusEditModal @click="$emit('cancelar')" :loading="loadingPrevius">
          Seguir Editando
        </PreviusEditModal>
        <SaveModal
          @click="$emit('guardar')"
          :loading="loadingSave"
          v-if="this.scenario.id == null"
        >
          Guardar cambios
        </SaveModal>
        <SaveModal @click="$emit('editar')" :loading="loadingSave" v-else>
          Guardar cambios
        </SaveModal>
      </div>
    </div>

    <div
      class="col-12 d-flex flex-column align-items-center p-0 m-0"
      v-if="eliminarRegistro"
    >
      <div class="my-4">
        <span class="text-danger-confir">{{ textMsgConfirmar }}</span>
      </div>
      <div class="mt-2 d-flex">
        <PreviusEditModal @click="$emit('cancelar')" :loading="loadingEdit">
          Seguir Editando
        </PreviusEditModal>
        <DelModal :loading="loadingDel" @click="$emit('eliminar')">
          Borrar {{ textDel }}
        </DelModal>
      </div>
    </div>
  </div>
</template>
<script>
import SaveModal from "@/components/core/button/save-modal.vue";
import ScenarioDatatable from "./scenario-datatable.vue";
import DelModal from "@/components/core/button/del-modal.vue";
import PreviusEditModal from "@/components/core/button/previus-edit-modal.vue";
import { mapState } from "vuex";
export default {
  name: "scenario-show",
  components: { SaveModal, PreviusEditModal, DelModal, ScenarioDatatable },
  computed: {
    ...mapState("modScenarios", [
      "scenarioselected",
      "lineDeals",
      "scenario",
      "scenarios",
    ]),
  },
  props: {
    textDel: {
      default: "",
      type: String,
    },
    loadingSave: {
      default: false,
      type: Boolean,
    },
    loadingEdit: {
      default: false,
      type: Boolean,
    },
    loadingPrevius: {
      default: false,
      type: Boolean,
    },
    loadingDel: {
      default: false,
      type: Boolean,
    },
    formulario: {
      type: Object,
    },
    eliminarRegistro: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["guardar", "cancelar", "editar", "eliminar"],
  data() {
    return {
      id: null,
      name: null,
      linedealid: null,
      linedeal: {
        id: "",
        name: "",
      },
      linedeals: [],
      textMsgConfirmar: "Al confirmar no podrás recuperar los cambios",
    };
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.text-danger-confir {
  color: #da1414;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
}
</style>